<template>
	<div class="animated fadeIn">
		<div class="row">
			<div class="col-xs-12">
				<h2>
					<i class="fa fa-fire text-success"></i>
					<span>编辑个人信息</span>
				</h2>
				<div class="pull-right">
					<CreateSaveButton :entity="user" :callback="save"/>
				</div>
			</div>
		</div>


		<div class="row">

			<div class="col-xs-12 m-t-md">

				<div class="form-group clear">
					<img class="thumb-lg pull-left m-r-md">
					<label class="control-label">头像</label>

					<div>
						<NbTank :tank="user.avatar"/>
					</div>

				</div>

				<div class="form-group">
					<label class="control-label">个人简介</label>
					<textarea class="form-control" rows="6" v-model="user.description"
					          placeholder="此处填写个人简介……"></textarea>
				</div>

			</div>
			<div class="col-xs-12 m-t-md">
				<div class="alert alert-danger" v-show="user.errorMessage">
					{{user.errorMessage}}
				</div>
				<div class="pull-right">
					<CreateSaveButton :entity="user" :callback="save"/>
				</div>
			</div>
		</div>

	</div>


</template>
<script>
	import {Notification} from 'element-ui';
	import NbTank from '../../../common/widget/NbTank';
	import CreateSaveButton from "../widget/CreateSaveButton.vue"
	import User from '../../../common/model/user/User';
	export default{
		data(){
			return {
				user: new User()
			}
		},
		watch: {},
		methods: {
			save(){

				let that = this;
				this.user.httpSave(function () {

					Notification.success({
						message: '修改信息成功！'
					});
					that.$router.push("/cgd/by/user/profile/" + that.user.id);

				});

			}
		},
		components: {
			NbTank,
			CreateSaveButton
		},
		mounted(){
			this.user.id = this.$store.state.route.params.id;
			if (this.user.id === this.$store.state.user.id + "") {
				this.user = this.$store.state.user;
			}

			if (this.user.id) {
				this.user.editMode = true;
				this.user.httpDetail();
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Edit.vue?0d1731ba